import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { Checkbox } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function DedupeMergePage() {
  const [mergedDuplicates, setMergedDuplicates] = useState(false);
  const [slicedBigClumps, setSlicedBigClumps] = useState(false);
  const [renamedForClarity, setRenamedForClarity] = useState(false);

  return (
    <TaskPage
      phase="gather"
      title="Dedupe & Merge"
      pageNumber={5}
      instruction="Scan titles for overlaps; merge near-duplicates. Quick rules: if 80% overlap in outcome or audience → merge under the clearer title. Keep the stronger evidence capsule. If two items are nested, slice the bigger one."
      whyItMatters="Plain-language guardrails + simple checklists help novices avoid expert blind spots without heavy math."
      coachRail={{
        timing: "10 minutes",
        tips: "80% overlap = merge. Keep stronger evidence. Slice bigger nested items.",
        debrief: "How many duplicates did we find? What patterns emerged?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Quick Rules</h3>
          <div className="space-y-3 text-sm text-[var(--text-sec)]">
            <p>• If 80% overlap in outcome or audience → merge under the clearer title</p>
            <p>• Keep the stronger evidence capsule</p>
            <p>• If two items are nested, slice the bigger one</p>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Checklist</h3>
          <div className="space-y-3">
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={mergedDuplicates}
                onChange={(e) => setMergedDuplicates(e.target.checked)}
                label="Merged duplicates"
              />
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={slicedBigClumps}
                onChange={(e) => setSlicedBigClumps(e.target.checked)}
                label="Sliced big clumps"
              />
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={renamedForClarity}
                onChange={(e) => setRenamedForClarity(e.target.checked)}
                label="Renamed for clarity"
              />
            </label>
          </div>
        </div>

        <Callout type="tip" phase="gather">
          <p className="text-sm">Review your list and identify duplicates. Merge similar items to reduce noise and focus on unique options.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






